import type { MessageKey } from '../en';

export const ja: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "新しい履歴ポイントに使う精度",
  "defaults.accuracy.title": "既定の GPS 精度",
  "defaults.actual.desc": "シミュレーション中の場所検索に使います",
  "defaults.actual.empty": "まだ保存されていません",
  "defaults.actual.emptyHint": "位置を許可し、シミュレーションなしでアプリを開くと取得できます。",
  "defaults.actual.pending": "電話がこの位置を保存します。同期はまだつながっていません。",
  "defaults.actual.refresh": "今すぐ更新",
  "defaults.actual.title": "実際の位置",
  "defaults.browserChip": "このブラウザ",
  "defaults.close": "閉じる",
  "defaults.color.desc": "新しいルートの線の色",
  "defaults.color.group": "ルートの色",
  "defaults.color.title": "ルートの色",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "日付、年 · 12 時間",
  "defaults.format.dayShort": "曜日と日付 · 12 時間",
  "defaults.format.eu": "EU の日付 · 24 時間",
  "defaults.format.fullDay": "完全な日付 · 12 時間",
  "defaults.format.iso": "ISO の日付 · 24 時間",
  "defaults.format.monthFirst": "月を先に · 24 時間",
  "defaults.format.shortDayYear": "曜日、日付、年 · 24 時間",
  "defaults.format.timeFirst": "時刻を先に · 24 時間",
  "defaults.format.us": "米国の日付 · 12 時間",
  "defaults.format.withSeconds": "秒あり · 12 時間",
  "defaults.itinAccuracy.desc": "新しい区間の GPS 精度",
  "defaults.itinAccuracy.title": "精度",
  "defaults.itinerary.desc": "新しい区間の既定値",
  "defaults.itinerary.title": "ルート",
  "defaults.joyAccuracy.desc": "ジョイスティックセッション作成時の開始 GPS 精度",
  "defaults.joyAccuracy.title": "既定の GPS 精度",
  "defaults.joyName.desc": "新しいジョイスティックセッションの既定の名前",
  "defaults.joyName.dialogTitle": "セッション名の形式を選ぶ",
  "defaults.joyName.title": "日付の形式",
  "defaults.joySpeed.desc": "ジョイスティックセッション作成時の開始速度",
  "defaults.joySpeed.title": "既定の速度",
  "defaults.joyUnit.desc": "ジョイスティックの速度を km/h または mph で表示し、調整します",
  "defaults.joystick.desc": "ジョイスティックセッションの既定値",
  "defaults.joystick.title": "ジョイスティック",
  "defaults.kilometers": "{n} km",
  "defaults.map.desc": "新しい地図の開き方",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "新しい地図画面の見た目",
  "defaults.mapTheme.group": "地図テーマ",
  "defaults.mapTheme.title": "地図テーマ",
  "defaults.marker.car": "車",
  "defaults.marker.desc": "ジョイスティックセッション作成時に使います。セッションごとに変更できます。",
  "defaults.marker.group": "既定のマーカー",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "既定のマーカー",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} m",
  "defaults.nameFormat.desc": "固定ポイントの既定の名前",
  "defaults.nameFormat.dialogSubtitle": "プレビューは今日の日付を使います。新しいポイントには短い形式を選びます。",
  "defaults.nameFormat.dialogTitle": "ポイント名の形式を選ぶ",
  "defaults.nameFormat.group": "日付の形式",
  "defaults.nameFormat.title": "日付の形式",
  "defaults.overlay.itinerary.desc": "ルートシミュレーションがバックグラウンドで続くときのフローティングプレーヤー",
  "defaults.overlay.itinerary.title": "自動ルート",
  "defaults.overlay.joystick.desc": "セッションがバックグラウンドで続くときのフローティングジョイスティック",
  "defaults.overlay.joystick.title": "ジョイスティック",
  "defaults.overlay.playlist.desc": "リストシミュレーションがバックグラウンドで続くときのフローティングプレーヤー",
  "defaults.overlay.playlist.title": "リスト",
  "defaults.overlay.stationary.desc": "固定シミュレーションがバックグラウンドで続くときのフローティングプレーヤー",
  "defaults.overlay.stationary.title": "固定ポイント",
  "defaults.plAccuracy.desc": "各リストピンに適用する GPS 精度",
  "defaults.plAccuracy.title": "項目ごとの精度",
  "defaults.player.desc": "オーバーレイプレーヤーとシミュレーションの操作",
  "defaults.player.title": "プレーヤー",
  "defaults.playlist.desc": "新しいリストピンの既定値",
  "defaults.playlist.title": "リスト",
  "defaults.polyline.desc": "ジョイスティックセッション中に描くルートの既定の色。",
  "defaults.polyline.group": "ポリラインの色",
  "defaults.polyline.title": "既定のポリライン色",
  "defaults.range.accuracyMax": "300 m",
  "defaults.range.accuracyMin": "0 m",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 m",
  "defaults.range.joyAccuracyMin": "1 m",
  "defaults.range.plAccuracyMax": "500 m",
  "defaults.range.plAccuracyMin": "0 m",
  "defaults.range.searchMax": "50 km",
  "defaults.range.searchMin": "3 km",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 秒",
  "defaults.range.timeMin": "0 秒",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "リセット",
  "defaults.search.itinerary": "地図の中心近くの結果を優先します",
  "defaults.search.playlist": "地図の中心近くの結果を優先します",
  "defaults.search.stationary": "ピンの近くの結果を優先します",
  "defaults.search.title": "検索半径",
  "defaults.seconds": "{n} 秒",
  "defaults.section.appearance": "表示",
  "defaults.section.camera": "カメラ",
  "defaults.section.history": "履歴",
  "defaults.section.location": "位置の文脈",
  "defaults.section.map": "地図",
  "defaults.section.motion": "動き",
  "defaults.section.overlay": "オーバーレイプレーヤー",
  "defaults.section.playlist": "リスト",
  "defaults.section.search": "検索",
  "defaults.section.style": "スタイル",
  "defaults.section.view": "地図",
  "defaults.sectionDefaults": "アプリの既定値",
  "defaults.sectionDefaultsDesc": "より速く滑らかな体験のために既定値を設定します",
  "defaults.sectionPlayer": "プレーヤー",
  "defaults.sectionPlayerDesc": "オーバーレイと再生の設定",
  "defaults.speed.desc": "新しい区間の再生速度",
  "defaults.speed.title": "既定の速度",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "新しい地図ポイントの既定値",
  "defaults.stationary.title": "固定ポイント",
  "defaults.summary.playerAll": "すべてのオーバーレイがオン",
  "defaults.summary.playerOff": "オーバーレイはオフ",
  "defaults.summary.playerSome": "4 件中 {on} 件がオン",
  "defaults.summary.zoom": "ズーム {n}",
  "defaults.syncNote": "今はこのブラウザに保存されます。同期がつながると、電話アプリがこの値を使います。",
  "defaults.theme.night": "ナイト",
  "defaults.theme.nightDesc": "暗い場所や夜のセッション向けの暗い地図色。",
  "defaults.theme.retro": "レトロ",
  "defaults.theme.retroDesc": "暖色のビンテージ調。古典的な地図の雰囲気です。",
  "defaults.theme.silver": "シルバー",
  "defaults.theme.silverDesc": "明るい灰色。日中に見やすいスタイルです。",
  "defaults.theme.standard": "標準",
  "defaults.theme.standardDesc": "なじみのある緑と青の、クラシックな Google マップの色。",
  "defaults.tilt.desc": "地図画面のカメラ角度",
  "defaults.tilt.title": "既定のカメラ傾斜",
  "defaults.time.desc": "次のピンに移るまでの待ち時間",
  "defaults.time.title": "項目ごとの時間",
  "defaults.tray.group": "トレイの高さ",
  "defaults.tray.large": "大",
  "defaults.tray.medium": "中",
  "defaults.tray.playlistDesc": "地図上で見えるリストパネル",
  "defaults.tray.small": "小",
  "defaults.tray.stationaryDesc": "地図上で見えるパネルの大きさ",
  "defaults.tray.title": "トレイの高さ",
  "defaults.unit.group": "速度の単位",
  "defaults.unit.itineraryDesc": "ルートモジュールの速度を km/h または mph で表示します",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "速度の単位",
  "defaults.view.grid": "グリッド",
  "defaults.view.group": "表示",
  "defaults.view.historyDesc": "保存したポイントの見せ方",
  "defaults.view.historyTitle": "履歴の表示",
  "defaults.view.list": "リスト",
  "defaults.view.playlistDesc": "保存したリストの見せ方",
  "defaults.view.playlistTitle": "リストの表示",
  "defaults.zoom.desc": "新しい地図の開始ズーム",
  "defaults.zoom.title": "既定のズーム",
  "language.defaultBadge": "既定",
  "language.empty": "この検索に合う言語はありません。",
  "language.lead": "英語（米国）が既定です。選択はこのブラウザに保存されます。",
  "language.listLabel": "言語",
  "language.preview": "模擬位置、リスト、ルート。",
  "language.previewLabel": "プレビュー",
  "language.searchLabel": "言語を検索",
  "language.searchPlaceholder": "言語を検索",
  "nav.account": "アカウント",
  "nav.account.desc": "プロフィール、Premium、サインイン。",
  "nav.analytics": "分析",
  "nav.analytics.desc": "MockLoc の活動、ネットワーク使用、同期の状態を把握します。",
  "nav.articles": "記事",
  "nav.articles.desc": "設定、再生、同期のガイド。",
  "nav.backup": "バックアップと同期",
  "nav.backup.desc": "クラウドバックアップと同期の状態。",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "モジュールと活動ごとのコイン使用の内訳。",
  "nav.dashboard": "ダッシュボード",
  "nav.dashboard.desc": "位置、リスト、ルート、アカウント活動の概要。",
  "nav.devices": "端末を管理",
  "nav.devices.desc": "MockLoc アカウントにサインインしている端末を確認します。",
  "nav.help": "ヘルプとサポート",
  "nav.help.desc": "会話を追い、MockLoc チームに助けを求めます。",
  "nav.history": "位置履歴",
  "nav.history.desc": "このアカウントがシミュレートした場所。",
  "nav.itinerary": "ルート",
  "nav.itinerary.desc": "保存したルートを作成、編集、管理します。",
  "nav.joystick": "ジョイスティックセッション",
  "nav.joystick.desc": "再生ルート、統計、保存したジョイスティックセッション。",
  "nav.notifications": "通知",
  "nav.notifications.desc": "同期、バックアップ、製品のお知らせ。",
  "nav.playlist": "リスト",
  "nav.playlist.desc": "順序のある模擬位置の集まり。",
  "nav.settings": "設定",
  "nav.settings.desc": "テーマ、言語、モバイルアプリの既定値。",
  "nav.stationary": "固定ポイント",
  "nav.stationary.desc": "このアカウントに保存された固定の模擬位置。",
  "nav.whatsNew": "アプリの新機能",
  "nav.whatsNew.desc": "MockLoc の新しい更新、修正、改善。",
  "settings.back": "設定",
  "settings.backDefaults": "アプリの既定値",
  "settings.defaults.shellDesc": "電話アプリが地図、ポイント、ルート、再生に使う値。",
  "settings.defaults.shellTitle": "アプリの既定値",
  "settings.home.defaults.desc": "電話アプリの地図、ポイント、リスト、ルート、ジョイスティック、プレーヤーの既定値。",
  "settings.home.defaults.title": "モバイルアプリの既定値",
  "settings.home.language.desc": "メニュー、ページタイトル、設定の言語を選びます。",
  "settings.home.language.title": "言語設定",
  "settings.home.theme.desc": "このブラウザの文字サイズ、色、ライトまたはダーク、フォント。",
  "settings.home.theme.title": "テーマ設定",
  "settings.language.shellDesc": "このウェブサイトの言語を選びます。",
  "settings.language.shellTitle": "言語",
  "settings.theme.shellDesc": "このブラウザの文字サイズ、色、ライトまたはダーク、フォント。",
  "settings.theme.shellTitle": "テーマ",
  "shell.account": "アカウント",
  "shell.accountMenu": "アカウントメニュー",
  "shell.accountMenuNamed": "アカウントメニュー、{name}",
  "shell.closeMenu": "メニューを閉じる",
  "shell.collapseSidebar": "サイドバーを折りたたむ",
  "shell.dashboardSubtitle": "模擬位置、リスト、ルートなどを一か所で管理します。",
  "shell.devicesLimit": "最大 3 台の端末で利用",
  "shell.expandSidebar": "サイドバーを広げる",
  "shell.goPremium": "Premium にする",
  "shell.logOut": "ログアウト",
  "shell.mainNav": "メインナビゲーション",
  "shell.noMatches": "一致する項目はありません",
  "shell.notifications": "通知",
  "shell.notificationsUnread": "通知、未読 {count} 件",
  "shell.openMenu": "メニューを開く",
  "shell.pages": "ページ",
  "shell.recent": "最近",
  "shell.searchLabel": "位置、リスト、ルート、記事を検索",
  "shell.searchPlaceholder": "位置、リスト、ルート、記事を検索...",
  "shell.searchResults": "検索結果",
  "shell.tagline": "模擬位置を、かんたんに",
  "shell.themeDarkTitle": "ダークテーマ",
  "shell.themeLightTitle": "ライトテーマ",
  "shell.themeToDark": "ダークテーマに切り替え",
  "shell.themeToLight": "ライトテーマに切り替え",
  "shell.there": "あなた",
  "shell.unlimitedCoins": "コイン無制限",
  "shell.unlimitedEverything": "すべて無制限",
  "shell.upgradeNow": "今すぐアップグレード",
  "shell.viewAllNotifications": "すべての通知を見る",
  "shell.welcome": "おかえりなさい、{name}",
  "theme.builtin": "組み込み",
  "theme.changesLabel": "変わるもの。",
  "theme.color.accent.changes": "ブランドの金と薄い金の面。イラストの細部も含みます。",
  "theme.color.accent.title": "アクセント",
  "theme.color.accent.where": "サインイン、記事、バッジの金色の強調。",
  "theme.color.danger.changes": "赤いエラー文と破壊的な操作。",
  "theme.color.danger.title": "危険",
  "theme.color.danger.where": "エラー、削除、未読の点。",
  "theme.color.info.changes": "ライトとダークで情報に使う青。",
  "theme.color.info.title": "情報",
  "theme.color.info.where": "青い状態、情報リンク、情報の印。",
  "theme.color.lead": "組み込みの色は、選ぶまでライトとダークで異なります。選んだ色は両方のテーマで使われます。ポイント、リスト、ルートに保存した色はそのままです。",
  "theme.color.primary.changes": "濃い紫、薄い紫の文字、やわらかい紫の面。",
  "theme.color.primary.title": "プライマリ",
  "theme.color.primary.where": "ボタン、選択中のメニュー、リンク、ブランドの紫。",
  "theme.color.success.changes": "緑の状態テキストと成功の印。",
  "theme.color.success.title": "成功",
  "theme.color.success.where": "同期済み、完了、前向きな状態。",
  "theme.color.title": "色",
  "theme.color.warning.changes": "アンバーの警告とコインに使う金。",
  "theme.color.warning.title": "警告",
  "theme.color.warning.where": "警告、コインの印、Premium の強調。",
  "theme.colorAria": "色 {title}",
  "theme.custom": "カスタム",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Arial から合成",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica または合成",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular と Bold はインストール済みです。ほかの太さは合成されます。",
  "theme.font.google-sans.note": "Regular ファイルは 400 と 500 をカバーします。Bold ファイルは 600 から 900 をカバーします。",
  "theme.font.group": "フォント",
  "theme.font.helvetica.note": "この端末では Helvetica、次に Helvetica Neue、次に Arial を使います。",
  "theme.font.inter.note": "サイトが今使っているフォントです。Regular から Black まで読み込まれています。",
  "theme.font.lead": "サイト全体で一つの書体を使います。Inter を選ぶと、マーケティングの見出しは Plus Jakarta Sans に戻ります。下の太さは画面がすでに使っているものです。",
  "theme.font.sample": "模擬位置を、かんたんに",
  "theme.font.title": "フォント",
  "theme.hexAria": "16 進 {title}",
  "theme.lead": "このブラウザの文字サイズ、色、ライトまたはダーク、フォントを選びます。100% は今の画面と同じです。ここの見本とサイトの残りは一緒に変わります。",
  "theme.manager": "テーマ管理",
  "theme.mode.dark": "ダーク",
  "theme.mode.darkHint": "暗い面と明るい文字。",
  "theme.mode.group": "テーマ",
  "theme.mode.lead": "上部バーのボタンと同じライトとダークの選択です。",
  "theme.mode.light": "ライト",
  "theme.mode.lightHint": "明るい面と暗い文字。",
  "theme.mode.title": "テーマ",
  "theme.previewBody": "このアカウントに保存された位置。",
  "theme.previewBold": "リスト準備完了",
  "theme.previewHelp": "順序のある模擬位置の集まり。",
  "theme.previewKicker": "ライブプレビュー",
  "theme.previewTitle": "模擬位置",
  "theme.reset": "リセット",
  "theme.resetAll": "すべてリセット",
  "theme.resetColors": "色をリセット",
  "theme.resetFont": "フォントをリセット",
  "theme.resetText": "文字をリセット",
  "theme.sizeAria": "{title} のサイズ",
  "theme.text.bold.changes": "15 px から 18 px の文字。",
  "theme.text.bold.sample": "Premium にする",
  "theme.text.bold.title": "太字",
  "theme.text.bold.where": "カードのタイトル、ブランド名、セクション見出し、大きなボタン。",
  "theme.text.descriptive.changes": "12 px から 13 px の文字。",
  "theme.text.descriptive.sample": "順序のある模擬位置の集まり。",
  "theme.text.descriptive.title": "説明",
  "theme.text.descriptive.where": "サブタイトル、ヘルプ文、バッジ、フッター、補助の行。",
  "theme.text.header.changes": "20 px 以上の文字。",
  "theme.text.header.sample": "固定ポイント",
  "theme.text.header.title": "見出し",
  "theme.text.header.where": "ページタイトル、大きな見出し、空の状態のタイトル、コイン残高などの大きな数字。",
  "theme.text.lead": "役割ごとに共有のサイズがあります。見本はその役割を示します。このページのスライダーは使いやすいよう固定サイズのままです。",
  "theme.text.normal.changes": "14 px の文字。",
  "theme.text.normal.sample": "このアカウントに保存された位置。",
  "theme.text.normal.title": "標準",
  "theme.text.normal.where": "ナビゲーションのラベル、標準ボタン、リストのタイトル、短い要約。",
  "theme.text.other.changes": "9 px から 11 px の文字。9 px 未満の印は固定です。",
  "theme.text.other.sample": "2 時間前に更新",
  "theme.text.other.title": "その他",
  "theme.text.other.where": "小さなラベル、時刻、グラフのラベル、キャプション。",
  "theme.text.title": "文字",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "模擬位置、リスト、ルート",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "使う場所。",
};
